import Skeleton from '@/common/components/skeleton/Skeleton';
import {
	ChatComposerSkeleton,
	ChatMessageBubbleSkeleton,
} from '../../chat.styles';
import { MESSAGE_SKELETONS } from './constants/chatConversationSkeleton.constants';

export const ChatMessagesSkeletonContent = () => (
	<>
		{MESSAGE_SKELETONS.map((item, index) => (
			<ChatMessageBubbleSkeleton
				key={index}
				$alignRight={item.alignRight}
				$width={item.width}
			>
				<Skeleton
					width="100%"
					height={item.height}
					minWidth="100%"
					minHeight={item.height}
					radius="14px"
				/>
			</ChatMessageBubbleSkeleton>
		))}
	</>
);

export const ChatComposerSkeletonBar = () => (
	<ChatComposerSkeleton aria-hidden="true">
		<Skeleton width="36px" height="36px" radius="999px" />
		<Skeleton width="36px" height="36px" radius="999px" />
		<Skeleton width="100%" height="40px" radius="999px" />
		<Skeleton width="40px" height="40px" radius="12px" />
	</ChatComposerSkeleton>
);
